const sources = {
  vehicles: {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [],
    },
    cluster: true,
    maxzoom: 18.9,
    clusterMaxZoom: 19,
    clusterRadius: 45,
    clusterProperties: {
      total_capacity: [
        '+',
        [
          'case',
          ['has', 'marker_counter'],
          ['to-number', ['get', 'marker_counter'], 1],
          1,
        ],
      ],
      total_bicycle: ['+', ['case', ['==', ['get', 'form_factor', ['get', 'vehicleType']], 'bicycle'], 1, 0]],
      total_cargo_bicycle: ['+', ['case', ['==', ['get', 'form_factor', ['get', 'vehicleType']], 'cargo_bicycle'], 1, 0]],
      total_car: ['+', ['case', ['==', ['get', 'form_factor', ['get', 'vehicleType']], 'car'], 1, 0]],
      total_scooter: ['+', ['case', ['==', ['get', 'form_factor', ['get', 'vehicleType']], 'scooter'], 1, 0]],
      total_moped: ['+', ['case', ['==', ['get', 'form_factor', ['get', 'vehicleType']], 'moped'], 1, 0]],
    },
  },
}

export default sources;